import { DocumentIcon } from '@heroicons/react/24/outline';
import { getPostMetadata } from '../../services/mockMetadata';
import { contentTypeConfig } from '../../utils/metadataHelpers';

/** Gray kind line for resource cards: content-type icon + Resource. */
export default function ResourceKindLabel({
  postId,
  title,
}: {
  postId?: number;
  title: string;
}) {
  const metadata =
    typeof postId === 'number' ? getPostMetadata({ id: postId, title: { rendered: title } }) : null;
  const Icon = metadata?.contentType ? contentTypeConfig[metadata.contentType].icon : DocumentIcon;

  return (
    <p className="flex items-center gap-1.5 text-sm font-medium text-gray-600">
      <Icon className="h-4 w-4 flex-shrink-0 text-gray-600" aria-hidden />
      Resource
    </p>
  );
}
